import { Component } from '@angular/core';

@Component({
  selector: 'app-minimal-navbar',
  templateUrl: './minimal-navbar.component.html',
  styleUrls: ['./minimal-navbar.component.scss'],
})
export class MinimalNavbarComponent {}
